<mat-vertical-stepper [linear]="true" #stepper class="call-operator">
  <mat-step [stepControl]="firstFormGroup">
    <ng-template matStepLabel>
      Empresa:
      <span *ngIf="business != null">
        <b>{{ business.name }}</b>
      </span>
    </ng-template>
    <p><small><b>Selecione uma empresa:</b></small></p>
    <app-business-selection
      (businessSelected)="businessSelected($event)"
    ></app-business-selection>
  </mat-step>

  <mat-step [stepControl]="secondFormGroup">
    <ng-template matStepLabel>
      Responsável:
      <span *ngIf="userBusiness != null">
        <b>{{ userBusiness.name }}</b>
      </span>
    </ng-template>
    <app-user-business-selection
      [business]="business"
      (userBusinessSelected)="userBusinessSelected($event)"
    ></app-user-business-selection>
    <div style="margin-top: 10px;">
      <button 
        class="responsive-table-desktop" 
        mat-raised-button 
        color="warn" 
        matStepperPrevious
      >
        Trocar Empresa
      </button>
      <button 
        class="responsive-table-mobile"
        fxFill
        mat-raised-button 
        color="warn" 
        matStepperPrevious
      >
        Trocar Empresa
      </button>
    </div>
  </mat-step>

  <mat-step [stepControl]="thirdFormGroup">
    <ng-template matStepLabel>
      <div fxLayout="row" fxLayoutAlign="start center">
        Detalhes do Chamado:
      </div>
      <span *ngIf="descriptionReady" class="responsive-table-desktop" style="margin-left: 10px;">
        <mat-chip-list>
          <mat-chip color="primary" selected>Tipo: {{ statusNamed }}</mat-chip>
          <mat-chip color="warn" selected>Prioridade: {{ priorityNamed }}</mat-chip>
        </mat-chip-list>
      </span>
    </ng-template>
    <app-call-description
      [user]="userBusiness"
      (textHasChanged)="descriptionHasChanged($event)"
      (typeHasChanged)="typeHasChanged($event)"
      (priorityHasChanged)="priorityHasChanged($event)"
    ></app-call-description>
    <div fxLayout.gt-md="row" fxLayout="column" fxLayoutGap="10px">
      <button mat-raised-button color="warn" matStepperPrevious>Trocar Usuário</button>
      <button mat-raised-button color="primary" matStepperNext>Ótimo, vamos finalizar</button>
    </div>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Salvar e Gerar Chamado</ng-template>
    <h3>Agora você só precisa confirmar.</h3>
    <p>Você pode conferir os dados acima antes de confirmar.</p>
    <div fxLayout.gt-md="row" fxLayout="column" fxLayoutGap="10px">
      <button mat-raised-button color="primary" (click)="confirmCall()">Confirmado!</button>
      <button mat-raised-button color="warn" (click)="cancelCall()">Cancelar</button>
      <button mat-button color="link" (click)="newCall()">Novo Chamado!</button>
    </div>
  </mat-step>
</mat-vertical-stepper>

<div fxLayout="column" fxLayoutAlign="start center" >


</div>
